/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const dimensions = {
  header: {
    height: {
      desktop: 88,
      mobile: 64,
    },
  },
  menu: {
    height: {
      desktop: 40,
    },
  },
  searchBar: {
    width: 340,
    height: 40,
  },
  productCard: {
    swatch: 20,
    thumbnail: 236,
  },
  pagination: {
    button: 40,
  },
  inputFields: {
    height: 45,
  },
};

export const dpColor = {
  background: "#0091FF"
}
